<template>
    <div class="map-container">
        <div :id="mapId" class="map"></div>
    </div>
</template>

<script>
import { createMap, createMarker, fitMapBounds, createInfoWindow } from '../utils/mapUtils';
import { round } from '../helpers/numberHelpers';

export default {
    props: {
        communities: {type: Array, required: true},
        mapId: {
            type: String,
            default: 'mlp-map'
        }
    },
    data: () => ({
        map: undefined,
        infoWindow: undefined,
        loaded: false,
        markers: [],
        dataCommunities: [],
    }),
    methods: {
        async handleMapInit() {
            try {
                this.map = await createMap(this.mapId);
                this.infoWindow = createInfoWindow();
                this.setCommunities();
            } catch (error) {
                console.error('Failed to initialize map:', error);
            }
        },
        setCommunities() {
            this.dataCommunities = [
                {latitude: 28.3644, longitude: -82.6934},
                {latitude: 27.8428, longitude: -82.6995},
                ...this.communities
            ];
            
            this.dataCommunities.forEach(this.createMarker);
            this.fitBounds();
        },
        async createMarker(community) {
            if (!community.latitude || !community.longitude) return;

            const marker = await createMarker({
                map: this.map,
                position: {
                    lat: community.latitude,
                    lng: community.longitude
                },
                icon: '/images/site/maps/white-pin.svg',
                title: community.name,
                visible: typeof community.is_active !== 'undefined' && community.is_active
            });

            if (community.id) {
                marker.addListener('click', () => {
                    this.infoWindow.close();
                    this.infoWindow.setContent(this.getInfoWindowTemplate(community));
                    this.infoWindow.open({
                        anchor: marker,
                        map: this.map
                    });
                });
            }

            this.markers.push(marker);
        },
        getInfoWindowTemplate(community) {
            return `<a href="${community.url}" target="_blank" class="community-card__title">Visit ${community.name}</a>`;
        },
        fitBounds() {
            fitMapBounds(this.map, this.markers);
        }
    }
};
</script>

<style scoped>
.map-container {
    width: 100%;
    height: 100%;
    min-height: 400px;
}
.map {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/components/apps/mlp-map.vue